/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
import $ from "jquery";

class SpotlightCards {
  constructor() {
    this.init();
  }

  init() {
    this.getPostGrid();
  }

  getPostGrid() {
    const spotlightCategory = $("#spotlight-category").val() ? '&category=' + $("#spotlight-category").val() : '';
    $.ajax({
      type: "GET",
      url: `/wp-json/clf/v1/spotlight-grid?post_type=spotlight${spotlightCategory}`,
      success: (dataGrid) => {
        if (dataGrid != undefined) {
          this.renderNewsCard(dataGrid.data);
          $(".loader").addClass("hide-loader");
        }
      },
      error: function () {
        //Error block
        console.log("error");
      },
    });
  }

  renderNewsCard(cards) {
    const $container = $("#clf-spotlight");

    const newsItem = cards.map((item, index) => {
      const readMoreText = item.spotlightData && item.spotlightData.is_video
      ? 'Watch Video'
      : 'Read More';
      let isModalLink =
        item.postType === "spotlight"
          ? `<a href="#spotlight-${index}" class="${item.postType}">${readMoreText}</a>`
          : `<a href="${item.link}" class="${item.postType}">Read More</a>`;
      let renderModal =
        item.postType === "spotlight" ? this.renderModal(item, index) : "";
      const validateTitle =
        item.spotlightData &&
        item.spotlightData.spotlightType === "with_subtitle"
          ? "sub-title"
          : "";

      return `<div class="grid-item clf-col-grid">
                        <div class="clf-card clf-${item.postType}">
                            <div class="card-image-container">
                                <img class="card-img-top" src="${item.image}" alt="${item.title}">
                            </div>
                            <div class="clf-card-body">
                                <h5>${item.title}</h5>
                                <p class="${validateTitle}">${item.excerpt}</p>
                                ${isModalLink}
                                <span class="category">${item.category}</span>
                            </div>
                        </div>
                        ${renderModal}
                    </div>`;
    });

    $container.append(newsItem);
  }

  renderModal(item, index) {
    const mediaValidation = item.spotlightData.is_video
      ? `<iframe src="${item.spotlightData.media}"></iframe>`
      : `<img src="${item.spotlightData.media.url}" alt="${item.title}">`;

    return (
      `<div id="spotlight-${index}" style="display:none">
                    <div class="clf2020-modal-container">
                        <div class="media-container">
                            ${mediaValidation}
                        </div>
                        <div class="body-container">
                            <div class="content-left">
                                <h2>${item.title}</h2>
                                <p>${item.spotlightData.content}</p>
                            </div>
                            <div class="content-right">
                                <h4>${item.spotlightData.related_content_title}</h4>
                                <ul>` +
      this.renderRelated(item.spotlightData) +
      `</ul>
                            </div>
                        </div>
                    </div>
                </div>`
    );
  }

  renderRelated(related) {
    if (related.related_content === undefined) {
      return "";
    }

    return related.related_content
      .map((item) => {
        return "<li><a href=" + item.url + ">" + item.title + "</a></li>";
      })
      .join("");
  }
}

export default SpotlightCards;
